import api from "skin/http";
import { type } from 'skin/event';
import menu from 'skin/store/menu';

//Регистрация компании
function signup(data) {
	return new Promise((resolve, reject) => {
		api.post('api/auth/signup', data)
		.then((res) => {
			const { data } = res;
			const user = JSON.stringify(data.user)
			localStorage.setItem('token', data.accessToken);
			localStorage.setItem('user', user);
			type('ok');
			menu.setLoad();
			resolve();
		})
		.catch((e) => {
			console.log('Error ', e.response?.data);
			let msg = e.response?.data?.message;
			console.log(e);
			if (!msg) return reject(e.toString());
			reject(msg);
		});
	})
}

export default signup